<template>
  <v-card tile elevation="0" style="margin-top: 1px" class="single-job-content-card">
    <div class="text-center">
      <v-dialog
        v-model="dialog"
        eager
        width="800"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="apply-job-form-btn"
          >
            <v-icon class="icon">mdi-text-box-check-outline</v-icon>
            Quick Connect
          </v-btn>
        </template>

        <v-card tile class="apply-job-form-dialog">
          <v-btn absolute right top icon @click="dialog = false" class="apply-job-form-dialog-close">
            <v-icon class="apply-job-form-dialog-close-icon">mdi-close</v-icon>
          </v-btn>

          <h3 class="apply-job-form-title">Quick Connect</h3>

          <div id="apply-now-form-dist"></div>
        </v-card>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import {moveElement} from '../../../utils';

export default {
  name: 'Dialog',
  data: () => ({
    dialog: false,
  }),
  mounted() {
    this.$nextTick(function () {
      moveElement('apply-now-form', 'apply-now-form-dist');
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/variables';

.single-job-content {

  &-card {
    padding: 5%;
  }

  .apply-job-form {

    &-btn {
      color: #FFFFFF;
      font-family: "Zilla Slab";
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 1px;
      line-height: 22px;
      text-align: center;
      border-radius: 8px;
      background-color: #243759 !important;
      padding: 20px !important;
      height: auto !important;
      width: 350px;
      max-width: 90%;

      .icon {
        margin-right: 10px;
      }
    }
  }
}

.apply-job-form {

  &-title {
    color: #243759;
    font-family: "Zilla Slab";
    font-size: 50px;
    font-weight: 600;
    letter-spacing: 1px;
    text-align: center;
    margin-bottom: 30px;
  }

  &-dialog {
    padding: 10%;
    border-radius: 0;

    &-close {
      $closeSize: 45;

      width: #{$closeSize + 10}px !important;
      height: #{$closeSize + 10}px !important;

      &-icon {
        font-size: #{$closeSize}px !important;
        height: #{$closeSize}px !important;
        width: #{$closeSize}px !important;
        color: #c4cbd0 !important;
      }
    }
  }

}

.form-container {
  margin-top: 20px;
}
</style>

<style lang="scss">
.apply-job-form {

  &-upload {
    margin: 20px 0;

    &-btn {

    }

    .el-upload {
      width: 100%;
      background-color: #f6f7f9;

      &-dragger {
        width: 100%;
        background-color: #f6f7f9;
        border: 0;
        height: auto;
        padding: 30px;
      }
    }
  }
}
</style>
